require('backbone');
require('backbone-model');
require('backbone-relational');
require('ICanHaz');
require('handlebars-old');
require('./util/deferredClosureQueue');
require('./util/encodedLetterString');
require('./rjmHandlebarsHelpers');
require('./dashboard.beta.coffee');
require('global');
// #Chart Builder required libraries
require('jquery-block-ui');
require('jquery-multi-select');
require('jquery-toggle-buttons');
// #Chart Builder models
require('./models/Client')
require('./models/CategorySelector')
require('./models/CategorySet')
require('./models/Chart')
require('./models/ChartBuilderViewState')
require('./models/CohortDescriptor')
require('./models/DataLimit')
require('./models/LSColumn')
require('./models/Restriction')
require('./models/RestrictionSequence')
require('./models/RestrictionSet')
require('./models/Series')
require('./models/TimeFrame')
require('./models/Trend')
require('./models/Slicer')
require('./models/GAConnection')
require('./models/CohortField')
require('./util/categoryValues')
// #Chart Builder Views
require('./chartBuilder/chartBuilder');
require('./chartBuilder/chartBuilder.blockableView');
require('./chartBuilder/chartBuilder.dropdownView');
require('./chartBuilder/chartBuilder.containerView');
require('./chartBuilder/chartBuilder.typeSelectorView');
require('./chartBuilder/chartBuilder.buttonsView');
require('./chartBuilder/chartBuilder.chartNameView');
require('./chartBuilder/chartBuilder.previewView');
require('./chartBuilder/chartBuilder.dimensionListView');
require('./chartBuilder/chartBuilder.dimensionValuesView');
require('./chartBuilder/chartBuilder.timeOptionsView');
require('./chartBuilder/chartBuilder.timeOptionsView.moving');
require('./chartBuilder/chartBuilder.timeOptionsView.specific');
require('./chartBuilder/chartBuilder.nonTimeOptionsView');
require('./chartBuilder/chartBuilder.timeIntervalView');
require('./chartBuilder/chartBuilder.filterItemView');
require('./chartBuilder/chartBuilder.filtersView');
require('./chartBuilder/chartBuilder.seriesView.perspective');
require('./chartBuilder/chartBuilder.chartStyleView');
require('./chartBuilder/chartBuilder.trendListView');
require('./chartBuilder/chartBuilder.cohortFieldView');
require('./chartBuilder/chartBuilder.cohortSizeView');
require('./chartBuilder/chartBuilder.cohortTimeOptionsView');
require('./chartBuilder/chartBuilder.cohortTimeOptionsView.all');
require('./chartBuilder/chartBuilder.cohortTimeOptionsView.moving');
require('./chartBuilder/chartBuilder.cohortTimeOptionsView.specific');
require('./chartBuilder/chartBuilder.cohortMemberSelectorView');

